/**
 * Browser file-download helpers.
 *
 * Same Blob + object-URL + synthetic-anchor pattern as the web app's PNG export
 * (apps/web/src/services/exportImageService.ts) — the two apps don't share a lib
 * package, so this is a deliberate small duplicate rather than a new dependency.
 */

/** Trigger a download of `value` serialized as pretty-printed JSON. */
export function downloadJson(value: unknown, fileName: string) {
  const blob = new Blob([JSON.stringify(value, null, 2)], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
